import { render, staticRenderFns } from "./BaseLoginForBusinessUser.vue?vue&type=template&id=d3da82c0&"
import script from "./BaseLoginForBusinessUser.vue?vue&type=script&lang=js&"
export * from "./BaseLoginForBusinessUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports